import { Card, CardContent, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import Domestic from "./domestic/Domestic";
import Global from "./global/Global";

const DashboardCommodityPrice = () => {
  return (
    <Card sx={{ minHeight: 300, boxShadow: "none" }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "16px", lg: "18px" },
            fontWeight: 700,
          }}
        >
          قیمت کالا
        </Typography>
      </CardContent>

      <Grid2 container spacing={2}>
        <Grid2 xs={12} lg={6}>
          <Domestic />
        </Grid2>
        <Grid2 xs={12} lg={6}>
          <Global />
        </Grid2>
      </Grid2>
    </Card>
  );
};

export default DashboardCommodityPrice;
